import React, { memo } from 'react';
import PropTypes from 'prop-types';

const Card75 = ({ positions }) => (
  <div className="card card--75">
    <div>
      <div className="inner">
        {positions &&
          positions.map((pos, i) => (
            <div className={`cell ${pos.selected ? 'active' : ''}`} key={pos.index} />
          ))}
      </div>
    </div>
  </div>
);

Card75.propTypes = {
  positions: PropTypes.array.isRequired
};

// PureComponent: SIMPLE props only, ALL children must be PURE too!
export default memo(Card75);
